import * as actNotification from 'actions/notifications';
import {
  Button,
  ContactCapital,
  FastLoanProcess,
  Input,
  MainCard,
  ToggleSwitch,
} from 'components/CapitalRevamp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './FastLoanForm.css';

class FastLoanForm extends Component {
  state = {
    form: {
      personal_full_name: '',
      personal_npwp: '',
      personal_gender: 'M',
      personal_place_of_birth: '',
      personal_date_of_birth: '',
      personal_mother_name: '',
      personal_phone_number: '',
      personal_marital_status: 'menikah',
      personal_address: '',
      personal_zipcode: '',
      personal_rt: '',
      personal_rw: '',
      personal_province: 'DKI Jakarta',
      personal_city: 'Jakarta Barat',
      domicile_address: '',
      domicile_zipcode: '',
      domicile_rt: '',
      domicile_rw: '',
      domicile_province: 'DKI Jakarta',
      domicile_city: 'Jakarta Barat',
      business_name: '',
      business_start_date: '',
      business_address: '',
      business_zipcode: '',
      business_rt: '',
      business_rw: '',
      business_province: 'DKI Jakarta',
      business_city: 'Jakarta Barat',
    },
    errors: {},
    isDomicileSame: false,
    agreement: false,
  };

  onInputChange = (type, value) => {
    const { form } = this.state;

    if (
      type === 'personal_rt' ||
      type === 'domicile_rt' ||
      type === 'business_rt'
    ) {
      value = value.replace(/[A-Za-z\W\s_]+/g, '');
      const split = 2;
      const chunk = [];

      for (let i = 0, len = value.length; i < len; i += split) {
        chunk.push(value.substr(i, split));
      }

      value = chunk.join('/').substr(0, 5);
    }

    if (type === 'personal_date_of_birth' || type === 'business_start_date') {
      value = value.replace(/[A-Za-z\W\s_]+/g, '');
      let split = 2;
      const chunk = [];

      for (let i = 0, len = value.length; i < len; i += split) {
        split = i >= 4 ? 2 : 4;
        chunk.push(value.substr(i, split));
      }

      value = chunk.join('-').substr(0, 10);
    }

    if (type === 'personal_npwp') {
      value = value.replace(/[A-Za-z\W\s_]+/g, '');
      let split = 6;
      const dots = [];

      for (let i = 0, len = value.length; i < len; i += split) {
        split = i >= 2 && i <= 6 ? 3 : i >= 8 && i <= 12 ? 4 : 2;
        dots.push(value.substr(i, split));
      }

      const temp = dots.join('.');
      value =
        temp.length > 12 ? `${temp.substr(0, 12)}-${temp.substr(12, 7)}` : temp;
    }

    form[type] = value;
    this.setState({ form });
  };

  onAgreementClick = value => {
    this.setState({ agreement: value });
  };

  onDomicileChange = value => {
    this.setState({ isDomicileSame: value }, () => this.validateForm());
  };

  validateForm = () => {
    const { form, isDomicileSame } = this.state;
    const errors = {};
    let formIsValid = true;

    const domicileForm = [
      'domicile_address',
      'domicile_zipcode',
      'domicile_rt',
      'domicile_province',
      'domicile_city',
    ];

    let dataForm = [
      'personal_full_name',
      'personal_npwp',
      'personal_place_of_birth',
      'personal_date_of_birth',
      'personal_mother_name',
      'personal_phone_number',
      'personal_address',
      'personal_zipcode',
      'personal_rt',
      'personal_province',
      'personal_city',
      'business_name',
      'business_start_date',
      'business_address',
      'business_zipcode',
      'business_rt',
      'business_province',
      'business_city',
    ];

    if (!isDomicileSame) {
      dataForm = [...dataForm, ...domicileForm];
    }

    for (let i = 0; i < dataForm.length; i++) {
      if (form[dataForm[i]] < 1) {
        formIsValid = false;
        errors[dataForm[i]] = 'Form harus diisi';
      }

      if (
        dataForm[i] === 'personal_date_of_birth' ||
        dataForm[i] === 'business_start_date'
      ) {
        const date = new Date(form[dataForm[i]]);
        try {
          const dateString = date.toISOString().substring(0, 10);

          if (form[dataForm[i]] !== dateString || date > new Date()) {
            formIsValid = false;
            errors[dataForm[i]] = 'Tanggal tidak valid';
          }
        } catch (e) {
          formIsValid = false;
          errors[dataForm[i]] = 'Tanggal tidak valid';
        }
      }

      if (
        dataForm[i] !== 'personal_rt' &&
        dataForm[i] !== 'domicile_rt' &&
        dataForm[i] !== 'business_rt' &&
        dataForm[i] !== 'domicile_city' &&
        dataForm[i] !== 'personal_city' &&
        dataForm[i] !== 'business_city'
      ) {
        if (/[^a-zA-Z0-9.\-+ ]/g.test(form[dataForm[i]])) {
          formIsValid = false;
          errors[dataForm[i]] =
            'Form hanya boleh diisi dengan huruf atau angka';
        }
      }
    }

    this.setState({ errors });
    return formIsValid;
  };

  onSubmit = () => {
    const { form, isDomicileSame } = this.state;
    if (this.validateForm()) {
      if (isDomicileSame) {
        form.domicile_address = form.personal_address;
        form.domicile_zipcode = form.personal_zipcode;
        form.domicile_rt = form.personal_rt;
        form.domicile_province = form.personal_province;
        form.domicile_city = form.personal_city;
      }
      const personal_rt = form.personal_rt.split('/')[0];
      const personal_rw = form.personal_rt.split('/')[1];
      const domicile_rt = form.domicile_rt.split('/')[0];
      const domicile_rw = form.domicile_rt.split('/')[1];
      const business_rt = form.business_rt.split('/')[0];
      const business_rw = form.business_rt.split('/')[1];
      form.personal_rt = personal_rt;
      form.personal_rw = personal_rw;
      form.domicile_rt = domicile_rt;
      form.domicile_rw = domicile_rw;
      form.business_rt = business_rt;
      form.business_rw = business_rw;
      form.business_start_date = `${form.business_start_date}T00:00:00`;
      form.personal_date_of_birth = `${form.personal_date_of_birth}T00:00:00`;
      form.personal_npwp = form.personal_npwp.replace(/[A-Za-z\W\s_]+/g, '');
      this.props.onFormSubmit(form);
    } else {
      this.props.showError('Harap mengisi seluruh form yang ada');
    }
  };

  render() {
    const { form, errors, agreement, isDomicileSame } = this.state;
    const { provinces, cities } = this.props;
    return (
      <div className={styles['content-wrapper']}>
        <div className={styles.row}>
          <div className={styles['form-wrapper']}>
            <MainCard border="blue" title="Form Aplikasi">
              <div className={styles['content-form']}>
                <p className={styles.note}>*Semua Wajib Diisi</p>
                <Input
                  label="Nama Pemilik Bisnis"
                  placeholder="Nama lengkap pemilik bisnis sesuai dengan KTP"
                  value={form.personal_full_name}
                  onChange={e =>
                    this.onInputChange('personal_full_name', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.personal_full_name}
                />
                <Input
                  label="Nomor NPWP"
                  placeholder="xx.xxx.xxx.x-xxx.xxx"
                  value={form.personal_npwp}
                  onChange={e =>
                    this.onInputChange('personal_npwp', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.personal_npwp}
                />
                <Input label="Jenis Kelamin">
                  <div className="row">
                    <div className="col-md-4">
                      <div>
                        <label className={styles['label-radio']}>
                          <input
                            type="radio"
                            className={styles['input-radio']}
                            name="gender"
                            id="M"
                            value="M"
                            checked={form.personal_gender === 'M'}
                            onChange={e =>
                              this.onInputChange(
                                'personal_gender',
                                e.target.value
                              )
                            }
                          />
                          Laki-laki
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                        <label className={styles['label-radio']}>
                          <input
                            type="radio"
                            className={styles['input-radio']}
                            name="gender"
                            id="F"
                            value="F"
                            checked={form.personal_gender === 'F'}
                            onChange={e =>
                              this.onInputChange(
                                'personal_gender',
                                e.target.value
                              )
                            }
                          />
                          Perempuan
                        </label>
                      </div>
                    </div>
                  </div>
                </Input>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      label="Tempat Lahir"
                      placeholder="Kota kelahiran Anda sesuai dengan KTP"
                      value={form.personal_place_of_birth}
                      onChange={e =>
                        this.onInputChange(
                          'personal_place_of_birth',
                          e.target.value
                        )
                      }
                      onBlur={() => this.validateForm()}
                      errorMessage={errors.personal_place_of_birth}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Tanggal Lahir"
                      placeholder="YYYY-MM-DD"
                      type="date"
                      value={form.personal_date_of_birth}
                      onChange={e =>
                        this.onInputChange(
                          'personal_date_of_birth',
                          e.target.value
                        )
                      }
                      onBlur={() => this.validateForm()}
                      errorMessage={errors.personal_date_of_birth}
                    />
                  </div>
                </div>
                <Input
                  label="Nama Ibu Kandung"
                  placeholder="Nama Lengkap Ibu Kandung"
                  value={form.personal_mother_name}
                  onChange={e =>
                    this.onInputChange('personal_mother_name', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.personal_mother_name}
                />
                <Input
                  label="Nomor Handphone Pemilik Bisnis"
                  placeholder="Nomor Handphone Pemilik Bisnis"
                  value={form.personal_phone_number}
                  onChange={e =>
                    this.onInputChange('personal_phone_number', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.personal_phone_number}
                />
                <Input label="Status Kawin">
                  <div className="row">
                    <div className="col-md-4">
                      <div>
                        <label className={styles['label-radio']}>
                          <input
                            type="radio"
                            className={styles['input-radio']}
                            name="maritalStatus"
                            id="menikah"
                            value="menikah"
                            checked={form.personal_marital_status === 'menikah'}
                            onChange={e =>
                              this.onInputChange(
                                'personal_marital_status',
                                e.target.value
                              )
                            }
                          />
                          Menikah
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                        <label className={styles['label-radio']}>
                          <input
                            type="radio"
                            className={styles['input-radio']}
                            name="maritalStatus"
                            id="cerai"
                            value="cerai"
                            checked={form.personal_marital_status === 'cerai'}
                            onChange={e =>
                              this.onInputChange(
                                'personal_marital_status',
                                e.target.value
                              )
                            }
                          />
                          Cerai
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                        <label className={styles['label-radio']}>
                          <input
                            type="radio"
                            className={styles['input-radio']}
                            name="maritalStatus"
                            id="lajang"
                            value="lajang"
                            checked={form.personal_marital_status === 'lajang'}
                            onChange={e =>
                              this.onInputChange(
                                'personal_marital_status',
                                e.target.value
                              )
                            }
                          />
                          Lajang
                        </label>
                      </div>
                    </div>
                  </div>
                </Input>
                <hr />
                <Input
                  label="Alamat Sesuai KTP"
                  placeholder="Alamat lengkap sesuai dengan KTP"
                  value={form.personal_address}
                  onChange={e =>
                    this.onInputChange('personal_address', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.personal_address}
                />
                <div className="row">
                  <div className="row col-md-8">
                    <div className="col-md-6">
                      <Input
                        label="Kode Pos"
                        placeholder="Kode Pos"
                        value={form.personal_zipcode}
                        onChange={e =>
                          this.onInputChange('personal_zipcode', e.target.value)
                        }
                        onBlur={() => this.validateForm()}
                        errorMessage={errors.personal_zipcode}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label="RT/RW"
                        placeholder="XX/XX"
                        value={form.personal_rt}
                        onChange={e =>
                          this.onInputChange('personal_rt', e.target.value)
                        }
                        onBlur={() => this.validateForm()}
                        errorMessage={errors.personal_rt}
                      />
                    </div>
                  </div>
                </div>
                <Input label="Provinsi" errorMessage={errors.personal_province}>
                  <select
                    className={styles['select-form']}
                    onChange={e =>
                      this.onInputChange('personal_province', e.target.value)
                    }
                    onBlur={() => this.validateForm()}
                    value={form.personal_province}
                  >
                    {provinces.map(prov => {
                      return (
                        <option key={prov.id} value={prov.name}>
                          {prov.name}
                        </option>
                      );
                    })}
                  </select>
                </Input>
                <Input
                  label="Kabupaten/Kota"
                  errorMessage={errors.personal_city}
                >
                  <select
                    className={styles['select-form']}
                    onChange={e =>
                      this.onInputChange('personal_city', e.target.value)
                    }
                    onBlur={() => this.validateForm()}
                    value={form.personal_city}
                  >
                    {cities.map(city => {
                      return (
                        <option key={city.id} value={city.name}>
                          {city.name}
                        </option>
                      );
                    })}
                  </select>
                </Input>
                <hr />
                <div className={styles['toggle-container']}>
                  {isDomicileSame ? (
                    <p className={styles['label-domicile']}>Alamat Domisili</p>
                  ) : (
                    <Input
                      label="Alamat Domisili"
                      placeholder="Alamat lengkap domisili Anda sekarang"
                      value={form.domicile_address}
                      onChange={e =>
                        this.onInputChange('domicile_address', e.target.value)
                      }
                      onBlur={() => this.validateForm()}
                      errorMessage={errors.domicile_address}
                    />
                  )}
                  <div className={styles['toggle-wrapper']}>
                    <p className={styles['toggle-label']}>
                      Sama dengan alamat KTP?
                    </p>
                    <ToggleSwitch
                      checked={isDomicileSame}
                      onClick={e => this.onDomicileChange(e.target.checked)}
                    />
                  </div>
                </div>
                {isDomicileSame && (
                  <div className={styles['domicile-card']}>
                    <div className={styles.info}>i</div>
                    <p className={styles['card-title']}>
                      Alamat, KodePos, RT/RW, Provinsi dan Kota sama dengan KTP
                    </p>
                  </div>
                )}
                {!isDomicileSame && (
                  <div>
                    <div className="row">
                      <div className="row col-md-8">
                        <div className="col-md-6">
                          <Input
                            label="Kode Pos"
                            placeholder="Kode Pos"
                            value={form.domicile_zipcode}
                            onChange={e =>
                              this.onInputChange(
                                'domicile_zipcode',
                                e.target.value
                              )
                            }
                            onBlur={() => this.validateForm()}
                            errorMessage={errors.domicile_zipcode}
                          />
                        </div>
                        <div className="col-md-6">
                          <Input
                            label="RT/RW"
                            placeholder="XX/XX"
                            value={form.domicile_rt}
                            onChange={e =>
                              this.onInputChange('domicile_rt', e.target.value)
                            }
                            onBlur={() => this.validateForm()}
                            errorMessage={errors.domicile_rt}
                          />
                        </div>
                      </div>
                    </div>
                    <Input
                      label="Provinsi"
                      errorMessage={errors.domicile_province}
                    >
                      <select
                        className={styles['select-form']}
                        onChange={e =>
                          this.onInputChange(
                            'domicile_province',
                            e.target.value
                          )
                        }
                        onBlur={() => this.validateForm()}
                        value={form.domicile_province}
                      >
                        {provinces.map(prov => {
                          return (
                            <option key={prov.id} value={prov.name}>
                              {prov.name}
                            </option>
                          );
                        })}
                      </select>
                    </Input>
                    <Input
                      label="Kabupaten/Kota"
                      errorMessage={errors.domicile_city}
                    >
                      <select
                        className={styles['select-form']}
                        onChange={e =>
                          this.onInputChange('domicile_city', e.target.value)
                        }
                        onBlur={() => this.validateForm()}
                        value={form.domicile_city}
                      >
                        {cities.map(city => {
                          return (
                            <option key={city.id} value={city.name}>
                              {city.name}
                            </option>
                          );
                        })}
                      </select>
                    </Input>
                  </div>
                )}
                <hr />
                <Input
                  label="Nama Usaha/Bisnis"
                  placeholder="Nama Usaha/Bisnis Anda"
                  value={form.business_name}
                  onChange={e =>
                    this.onInputChange('business_name', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.business_name}
                />
                <div className="row">
                  <div className="col-md-8">
                    <Input
                      label="Tanggal Berdirinya Usaha/Bisnis"
                      placeholder="YYYY-MM-DD"
                      type="date"
                      value={form.business_start_date}
                      onChange={e =>
                        this.onInputChange(
                          'business_start_date',
                          e.target.value
                        )
                      }
                      onBlur={() => this.validateForm()}
                      errorMessage={errors.business_start_date}
                    />
                  </div>
                </div>
                <Input
                  label="Alamat Usaha/Bisnis"
                  placeholder="Alamat lengkap Usaha/Bisnis Anda"
                  value={form.business_address}
                  onChange={e =>
                    this.onInputChange('business_address', e.target.value)
                  }
                  onBlur={() => this.validateForm()}
                  errorMessage={errors.business_address}
                />
                <div className="row">
                  <div className="row col-md-8">
                    <div className="col-md-6">
                      <Input
                        label="Kode Pos"
                        placeholder="Kode Pos"
                        value={form.business_zipcode}
                        onChange={e =>
                          this.onInputChange('business_zipcode', e.target.value)
                        }
                        onBlur={() => this.validateForm()}
                        errorMessage={errors.business_zipcode}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label="RT/RW"
                        placeholder="XX/XX"
                        value={form.business_rt}
                        onChange={e =>
                          this.onInputChange('business_rt', e.target.value)
                        }
                        onBlur={() => this.validateForm()}
                        errorMessage={errors.business_rt}
                      />
                    </div>
                  </div>
                </div>
                <Input label="Provinsi" errorMessage={errors.business_province}>
                  <select
                    className={styles['select-form']}
                    onChange={e =>
                      this.onInputChange('business_province', e.target.value)
                    }
                    onBlur={() => this.validateForm()}
                    value={form.business_province}
                  >
                    {provinces.map(prov => {
                      return (
                        <option key={prov.id} value={prov.name}>
                          {prov.name}
                        </option>
                      );
                    })}
                  </select>
                </Input>
                <Input
                  label="Kabupaten/Kota"
                  errorMessage={errors.business_city}
                >
                  <select
                    className={styles['select-form']}
                    onChange={e =>
                      this.onInputChange('business_city', e.target.value)
                    }
                    onBlur={() => this.validateForm()}
                    value={form.business_city}
                  >
                    {cities.map(city => {
                      return (
                        <option key={city.id} value={city.name}>
                          {city.name}
                        </option>
                      );
                    })}
                  </select>
                </Input>
                <hr />
                <div>
                  <label>
                    <input
                      type="checkbox"
                      checked={agreement}
                      onClick={e => this.onAgreementClick(e.target.checked)}
                    />
                    &nbsp; Dengan mengeklik Apply, anda setuju dengan&nbsp;
                    <a
                      href="https://s3-ap-southeast-1.amazonaws.com/backoffice.mokapos.com/capital/TnC+Bizloan+PTBC.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Syarat dan Ketentuan
                    </a>
                    &nbsp; Moka Capital Fast Loan
                  </label>
                </div>
                <div className={styles['form-action']}>
                  <Button
                    title="Ajukan"
                    onClick={this.onSubmit}
                    disabled={!agreement}
                  />
                </div>
              </div>
            </MainCard>
          </div>
        </div>
        <div className={styles.line} />
        <div className={styles.row}>
          <div className={styles['process-wrapper']}>
            <FastLoanProcess />
          </div>
          <ContactCapital />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showError: value => dispatch(actNotification.error(value)),
  };
}

function mapStateToProps(state) {
  const { provinces, cities } = state.capital.fastLoan;
  return {
    provinces,
    cities,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FastLoanForm);
